import React from "react";
import { ArrowLeft } from "lucide-react";
import ActionSummaryCard from "./ActionSummaryCard";
import ActionTabs from "./ActionTabs";
import { useNavigate } from "react-router-dom";

const ActionRequiredBoard = ({ overdueCount, leaveCount, dueSoonCount, tasksCount }) => {
    const itemCount = overdueCount + leaveCount + dueSoonCount + tasksCount;
    const navigate = useNavigate();
  return (
    <div 
      className="space-y-6">
      <button 
        className="flex items-center border rounded-xl px-2 py-1 gap-2 dark:text-white"
        onClick={() => navigate("/console/dashboard")}>
          <ArrowLeft className="w-4 h-4 dark:text-white"/> 
          Back to Dashboard
      </button>

      <div className="flex items-start justify-between gap-3">
        <div>
          <h1 className="label-gradient red">Action Required</h1>
          <p className="muted-text mt-1 text-[12px]">Review and manage pending approvals, invoices, and tasks</p>
        </div>
        <span className="status-indicator bg-gradient-to-r from-red-500 to-pink-500 text-white text-[10px] px-2.5 py-0.5 animate-pulse">
          {itemCount} Items
        </span>
      </div>
        <ActionSummaryCard 
          leaveCount={leaveCount}
          overdueCount={overdueCount}
          dueSoonCount={dueSoonCount}
          tasksCount={tasksCount}
        />
        <ActionTabs 
          leaveCount={leaveCount}
          overdueCount={overdueCount}
          dueSoonCount={dueSoonCount}
          tasksCount={tasksCount}
        />
    </div>
  );
};
export default ActionRequiredBoard;
